/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NamespaceCreateRequest { 
    /**
     * The Namespace code
     */
    namespaceCode: string;
    /**
     * An optional charge code that is associated with the Namespace
     */
    chargeCode?: string;
    /**
     * An optional default record flag that is associated with the Namespace
     */
    defaultRecordFlag?: boolean;
    /**
     * Indicates default record code that is associated with the Namespace
     */
    defaultRecordCode?: string;
}
